(function () {
  var proxy = document.querySelector('.navigation--left');
  if (!proxy || !window.jQuery) return;

  function menuFor(toggle) {
    return document.getElementById(toggle.getAttribute('aria-controls'));
  }
  function isOpen(toggle) {
    var menu = menuFor(toggle);
    return !!menu && menu.closest('li').classList.contains('navigation__item--show-children');
  }
  function setOpen(toggle, open) {
    jQuery(toggle.closest('li')).trigger(open ? 'mouseenter' : 'mouseleave');
  }
  function links(menu) {
    return Array.prototype.filter.call(menu.querySelectorAll('a[href], button'), function (el) {
      return el.getClientRects().length > 0;
    });
  }
  function toggleFor(menu) {
    return proxy.querySelector('.navigation__children-toggle[aria-controls="' + menu.id + '"]');
  }

  var toggles = proxy.querySelectorAll('.navigation__children-toggle');
  var observer = new MutationObserver(function () {
    toggles.forEach(function (toggle) {
      toggle.setAttribute('aria-expanded', String(isOpen(toggle)));
    });
  });
  toggles.forEach(function (toggle) {
    var menu = menuFor(toggle);
    if (menu) observer.observe(menu.closest('li'), { attributes: true, attributeFilter: ['class'] });
  });

  proxy.addEventListener('click', function (e) {
    var toggle = e.target.closest('.navigation__children-toggle');
    if (!toggle) return;
    e.preventDefault();
    setOpen(toggle, !isOpen(toggle));
  });

  proxy.addEventListener('keydown', function (e) {
    var toggle = e.target.closest('.navigation__children-toggle');
    if (!toggle || !isOpen(toggle)) return;
    if (e.key === 'Escape') {
      setOpen(toggle, false);
    } else if (e.key === 'Tab' && !e.shiftKey) {
      var items = links(menuFor(toggle));
      if (items.length) {
        e.preventDefault();
        items[0].focus();
      }
    }
  });

  document.getElementById('main-nav').addEventListener('keydown', function (e) {
    var menu = e.target.closest('.navigation__tier-2-container');
    var toggle = menu && toggleFor(menu);
    if (!toggle) return;
    var items = links(menu);
    if (e.key === 'Escape') {
      e.preventDefault();
      setOpen(toggle, false);
      toggle.focus();
    } else if (e.key === 'Tab' && e.shiftKey && e.target === items[0]) {
      e.preventDefault();
      toggle.focus();
    } else if (e.key === 'Tab' && !e.shiftKey && e.target === items[items.length - 1]) {
      // Continue to the next top-level item instead of the page content.
      e.preventDefault();
      setOpen(toggle, false);
      var next = toggle.closest('li').nextElementSibling;
      (next ? next.querySelector('.navigation__link') : toggle).focus();
    }
  });
})();
